<template>
    <app-data-table
        :fields="fields"
        :items="tableData"
        @sort="onSort"
        :current-page="data.current_page"
        :last-page="data.last_page"
        :from="data.from"
        :to="data.to"
        :total="data.total"
        :per-page="data.per_page"
        :on-change-page="onChangePage"
    >
        <template slot="entry_date" slot-scope="{ item }">
            {{ item.entry_date | date }}
        </template>

        <template slot="photos" slot-scope="data">
            <b-button size="sm" v-if="!data.detailsShowing" :disabled="!data.item.cargo_vehicle_entry_photos.length" @click.stop="data.toggleDetails" variant="primary">Fotos <b-badge>{{ data.item.cargo_vehicle_entry_photos.length }}</b-badge></b-button>
            <b-button size="sm" v-else variant="danger" @click.stop="data.toggleDetails">Cerrar</b-button>
        </template>

        <template slot="actions" slot-scope="{ item }">
            <b-button size="sm" variant="primary" v-if="userCan('view-cargo-vehicle-entry')" @click="seeCard(item)"><i class="fa fa-search-plus" aria-hidden="true"></i></b-button>
            <b-button size="sm" variant="primary" v-if="userCan('create-cargo-vehicle-departure')" @click="registerVehicleDeparture(item)"><i class="fa fa-sign-out"></i> Registrar salida</b-button>
            <b-button size="sm" variant="primary" v-if="userCan('create-cargo-vehicle-entry-file')" @click="uploadPhotos(item)"><i class="fa fa-cloud-upload" aria-hidden="true"></i></b-button>
            <b-button size="sm" variant="danger" v-if="userCan('delete-cargo-vehicle-entry')" @click="removeEntry(item)"><i class="fa fa-trash"></i></b-button>
        </template>

        <template slot="row-details" slot-scope="data">
            <div class="d-flex justify-content-center">
                <div class="w-50">
                    <b-carousel id="carousel1"
                        style="text-shadow: 1px 1px 2px #333;"
                        controls
                        indicators
                        background="#ababab"
                        :interval="4000"
                        img-width="350px"
                        img-height="200px"
                    >
                        <b-carousel-slide v-for="photo in data.item.cargo_vehicle_entry_photos" img-height="200" :key="photo.id" :img-src="photo.photo_url"
                    ></b-carousel-slide>
                    </b-carousel>
                </div>
            </div>
        </template>
    </app-data-table>
</template>
<script>
export default {
    props: {
        data: {
            type: Object
        },
        isVigilant: {
            type: Boolean
        }
    },
    data(){
        return {
            fields: [
                {
                    key: 'client.name',
                    label: 'Cliente',
                },
                {
                    key: 'plate',
                    label: 'Placa',
                },
                {
                    key: 'entry_date',
                    label: 'Fecha entrada',
                },
                {
                    key: 'check_in',
                    label: 'Hora de entrada',
                },
                {
                    key: 'entry_registered_by.name',
                    label: 'Registrado por',
                },
                {
                    key: 'entry_cargo_driver.name',
                    label: 'Conductor entrada',
                },
                    
                {
                    key: 'material',
                    label: 'Material',
                },
                {
                    key: 'photos',
                    label: 'Fotos',
                    sortable: false
                },
                {
                    key: 'actions',
                    label: 'Acciones'
                }
            ],
            slide: 1
        }
    },
    computed: {
        tableData(){
            if(!this.data || !this.data.data) return [];
            return this.data.data.map(item => ({...item}));
        }
    },
    methods: {
        onChangePage(page){
            this.$emit('change-page', page);
        },
        registerVehicleDeparture(data){
            this.$emit('register-vehicle-departure', data);
        },
        removeEntry(data){
            this.$emit('remove-cargo-vehicle-entry', data);
        },
        uploadPhotos(data){
            this.$emit('upload-photos', data);
        },
        seeCard(data){
            this.$emit('see-card', data);
        },
        onSort(ctx) {
            this.$emit('sort', ctx);
        },
    }
}
</script>